import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Layout";
import PrivacyPolicy from "@/components/PrivacyPolicy";

const PrivacyPolicyPage = () => (
  <Layout>
    <PrivacyPolicy />
  </Layout>
);

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default PrivacyPolicyPage;
